import dynamic from 'next/dynamic';
import Loading from './Loading';

const Dynamic = (file, opts = {}) => {
  const options = { ssr: false, loading: Loading, timeout: 30000, ...opts };
  return dynamic(file, { ...options });
};

export default Dynamic;
